module.exports = __webpack_public_path__ + "static/img/title-text.e7930893.png";